<template>
  <div class="notice-all">
    <div class="notice-contain">
      <Header></Header>
      <typeNav></typeNav>
      <div class="addressBox">
        <img src="/image/address.png" alt />
        <span class="span1">当前页面</span>
        <!-- <span class="span1">/</span>
        <span class="span1">首页</span>-->
        <span class="span1">/</span>
        <span class="span2">{{$route.params.primaryColName}}</span>
      </div>
      <div class="noticeBox">
        <div class="notice-left">
          <div class="head-text">{{$route.params.primaryColName}}</div>
          <div class="nav-box">
            <div v-for="(item,index) in noticeNavList" :key="index">
              <div
                class="nav-item"
                @mouseenter="enterNotice(index)"
                :class="{ noticeActive: noticeNavIndex == index || noticeNavIndex2 == index }"
                @click="chooseType(index,item)"
                @mouseleave="leaveNotice"
              >
                <img src="/image/class.png" alt />
                <span>{{item.secondaryColName}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="notice-right">
          <noticeBox
            v-if="isMore"
            :noticeList="noticeList"
            :total="total"
            :title="title"
            @changePageNo="changePageNo"
            @changePageSize="changePageSize"
          ></noticeBox>
          <detailBox :noP="true" v-else></detailBox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reqNoticeNavList, reqNoticeList } from "@/api";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Notice",
  data() {
    return {
      noticeParams: {
        secondaryColId: "",
        pageNum: 1, //当前分页器的页码  【默认初始值:1】
        pageSize: 10 //代表当前一页显示几条数据 【默认初始值:10】
      },
      total: 0,
      title: "",
      noticeNavIndex: 0,
      noticeNavIndex2: 0,
      noticeNavList: [
        // "首页",
        // "通知公告",
        // "学会工作",
        // "教研评审",
        // "会员风采",
        // "职教动态",
        // "招生培训",
        // "升学就业"
      ],
      noticeList: [
        // {
        //   head:
        //     "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
        //   data: "2023-09-11"
        // },
        // {
        //   head:
        //     "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
        //   data: "2023-09-11"
        // },
        // {
        //   head:
        //     "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
        //   data: "2023-09-11"
        // },
        // {
        //   head:
        //     "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
        //   data: "2023-09-11"
        // },
        // {
        //   head:
        //     "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
        //   data: "2023-09-11"
        // },
        // {
        //   head:
        //     "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
        //   data: "2023-09-11"
        // },
        // {
        //   head:
        //     "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
        //   data: "2023-09-11"
        // },
        // {
        //   head:
        //     "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
        //   data: "2023-09-11"
        // },
        // {
        //   head:
        //     "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
        //   data: "2023-09-11"
        // },
        // {
        //   head:
        //     "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
        //   data: "2023-09-11"
        // }
      ],
      isMore: true
    };
  },
  watch: {
    async $route() {
      await this.getNoticeNavList();
      this.getNoticeList();
    }
  },
  // beforeMount() {
  //  if(this.$route.query) {

  //  }
  // },
  async mounted() {
    await this.getNoticeNavList();
    this.getNoticeList();
  },
  methods: {
    async getNoticeNavList() {
      this.title = "";
      this.noticeParams.secondaryColId = "";
      let result = await reqNoticeNavList(this.$route.query.id);
      if (result.resultCode == 10000) {
        this.noticeNavList = result.result;
        if (this.noticeNavList == "") return;
        this.noticeParams.secondaryColId = this.noticeNavList[0].id;
        // this.noticeParams.secondaryColId = 1;
        this.title = this.noticeNavList[0].secondaryColName;
      }
      // console.log("666");
    },
    async getNoticeList() {
      this.noticeList = [];
      // this.total = 0
      if (this.noticeParams.secondaryColId == "") {
        this.total = 0;
        return;
      }
      let result = await reqNoticeList(this.noticeParams);
      if (result.resultCode == 10000) {
        this.noticeList = result.result.resultList;
        this.total = result.result.totalCount;
      }
    },
    enterNotice(index) {
      this.noticeNavIndex = index;
    },
    leaveNotice() {
      this.noticeNavIndex = -1;
    },
    changePageNo(pageNum) {
      this.noticeParams.pageNum = pageNum;
      this.getNoticeList();
    },
    changePageSize(pageSize) {
      this.noticeParams.pageSize = pageSize;
      this.getNoticeList();
    },
    async chooseType(index, item) {
      // if (index % 2 != 0) {
      //   this.isOne = false;
      // } else {
      //   this.isOne = true;
      // }
      this.noticeNavIndex2 = index;
      this.noticeParams.secondaryColId = item.id;
      this.title = item.secondaryColName;
      await this.getNoticeList();
      //  if(this.noticeList.length == 1) {
      //      this.isOne = true;
      //  }else {
      //    this.isOne = false;
      //  }
      // this.$router.push({
      //   name: item,
      //   // query: { keyword: "ABC" }
      // });
    }
  }
};
</script>

<style  scoped lang="less">
.notice-all {
  background: linear-gradient(#79c6ff 0%, #b1daf8 59%, #d5ecfe 100%);
  margin: 0 auto;
  width: 100%;
  padding-bottom: 24px;
}
.notice-contain {
  width: 1200px;
  margin: 0 auto;
  .addressBox {
    margin: 20px 0;
    display: flex;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
    }
    .span1 {
      margin-left: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
    }
    .span2 {
      margin-left: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0052d9;
      line-height: 22px;
    }
  }
  .noticeBox {
    width: 1200px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    .notice-left {
      width: 232px;
      box-sizing: border-box;
      border-right: 1px solid #e7e7e7;
      .head-text {
        padding: 11px 0 11px 24px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #104584;
        border-radius: 8px 0 0 0;
        border-left: 4px solid #1286c4;
        border-bottom: 1px solid #e7e7e7;
      }
      .nav-box {
        padding: 16px 8px;
        box-sizing: border-box;
        .nav-item {
          width: 216px;
          height: 36px;
          padding-left: 18px;
          box-sizing: border-box;
          background: #fff;
          border-radius: 3px;
          display: flex;
          align-items: center;
          cursor: pointer;
          img {
            width: 16px;
            height: 15px;
          }
          span {
            margin-left: 10px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #0052d9;
            line-height: 22px;
            color: rgba(0, 0, 0, 0.6);
          }
        }
        .noticeActive {
          background: #ecf2fe !important;
          // img {
          //    background: rgba(0, 0, 0, 0.6);
          // }
          span {
            color: #0052d9 !important;
          }
        }
      }
    }
    .notice-right {
      flex: 1;
    }
  }
}

/* 大型桌面端样式 */
@media only screen and (min-width: 993px) {
  .notice-all {
    background: linear-gradient(#79c6ff 0%, #b1daf8 59%, #d5ecfe 100%);
    margin: 0 auto;
    width: 100%;
    padding-bottom: 24px;
  }
  .notice-contain {
    width: 1200px;
    margin: 0 auto;
    .addressBox {
      margin: 20px 0;
      display: flex;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
      .span1 {
        margin-left: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }
      .span2 {
        margin-left: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0052d9;
        line-height: 22px;
      }
    }
    .noticeBox {
      width: 1200px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      display: flex;
      .notice-left {
        width: 232px;
        box-sizing: border-box;
        border-right: 1px solid #e7e7e7;
        .head-text {
          padding: 11px 0 11px 24px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #104584;
          border-radius: 8spx 0 0 0;
          border-left: 4px solid #1286c4;
          border-bottom: 1px solid #e7e7e7;
        }
        .nav-box {
          padding: 16px 8px;
          box-sizing: border-box;
          .nav-item {
            width: 216px;
            height: 36px;
            padding-left: 18px;
            box-sizing: border-box;
            background: #fff;
            border-radius: 3px;
            display: flex;
            align-items: center;
            img {
              width: 16px;
              height: 15px;
            }
            span {
              margin-left: 10px;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #0052d9;
              line-height: 22px;
              color: rgba(0, 0, 0, 0.6);
            }
          }
          .noticeActive {
            background: #ecf2fe !important;
            // img {
            //    background: rgba(0, 0, 0, 0.6);
            // }
            span {
              color: #0052d9 !important;
            }
          }
        }
      }
      .notice-right {
        flex: 1;
      }
    }
  }
}
</style>